import Component from "../abstracts/Component";


export default class CarouselModuleComponent extends Component {
  get COMPONENTNAME() {
    return 'CarouselModuleComponent';
  }

  get SELECTORS() {
    return {
      main: '[data-carousel="true"]:not(.slick-initialized)',
      navWrapper: '[data-nav-wrapper]',
      prevArrow: '[data-nav-wrapper] [data-prev-arrow]',
      nextArrow: '[data-nav-wrapper] [data-next-arrow]',
      navDots: '[data-nav-wrapper] [data-nav-dots]',
      card: '[data-card]',
      content: '[data-content]',
      carousel: '[data-is-carousel="true"]',
      disabledCarousel: '[data-is-carousel="false"]',
    };
  }

  get CSS() {
    return {
      hidden: '--hidden',
    };
  }

  importLibrary() {
    return new Promise((resolve, reject) => {
      this.moduleLoader.loadCarouselAndExecute(
        module => { resolve(module) },
        error => { reject(error) }
      );
    });
  }

  readDOM() {
    return {
      main: this.$component.querySelector(this.SELECTORS.main),
      navWrapper: this.$component.querySelector(this.SELECTORS.navWrapper),
      prevArrow: this.$component.querySelector(this.SELECTORS.prevArrow),
      nextArrow: this.$component.querySelector(this.SELECTORS.nextArrow),
      navDots: this.$component.querySelector(this.SELECTORS.navDots),
      // cards: Array.from(this.$component.querySelectorAll(this.SELECTORS.card)),
      content: this.$component.querySelector(this.SELECTORS.content),
      carousel: this.$component.querySelector(this.SELECTORS.carousel),
      disabledCarousel: this.$component.querySelector(this.SELECTORS.disabledCarousel),
    }
  }

  render() {
    super.render();

    this.slickInstance = null;
    this.dom = this.readDOM();

    if (!this.dom.main) return;

    // must be before slick is initialized and clones cards
    const cards = Array.from(this.dom.carousel.querySelectorAll(this.SELECTORS.card))

    this.importLibrary().then(() => {
      const mq = window.matchMedia('screen and (max-width: 767px)');
      this.initCarousel(mq.matches, cards.length);
      mq.addEventListener('change', (e) => {
        this.initCarousel(e.matches, cards.length);
      });
    });
  }

  initCarousel(isMobile = false, cardsNumber = 0) {

    const isSideContent = this.dom.content && this.dom.content.dataset.content === 'side';
    const isMobileCarousel = this.$component.dataset.mobileCarousel === 'true';

    const opts = {
      dots: true,
      arrows: true,
      autoplay: false,
      swipeToSlide: true,
      centerMode: true,
      variableWidth: false,
      slidesToScroll: 1,
      infinite: !isSideContent,
      slidesToShow: isSideContent ? 2 : 3,
      centerPadding: '12.50%',

      prevArrow: this.dom.prevArrow,
      nextArrow: this.dom.nextArrow,
      appendDots: this.dom.navDots,

      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            infinite: true,
            dots: true,
            arrows: true,
            autoplay: false,
            swipeToSlide: true,
            centerMode: true,
            variableWidth: false,
            centerPadding: '12.50%',
          }
        },
      ],
    }

    const isInitialized = this.dom.main.classList.contains('slick-initialized')
    if (!isInitialized) {
      this.slickInstance = $(this.dom.main).slick(opts)
    }


    // fix slick "responsivness"
    // don't initialize carousel if (ORs):
    // - desktop: text is top and viewport is >= md and there are <= 4 card
    // - mobile: flag is unchecked
    // in both cases, skip init only if already is not initialized in order to
    // not break responsivness

    // WARN: `unslick` removes slides from the dom, it doesn't just disable the carousel
    // const isInitialized = this.dom.main.classList.contains('slick-initialized')
    const mobileCarouselEnabled = isMobile && isMobileCarousel;
    const hasEnoughDesktopCards = !isMobile && !isSideContent && cardsNumber > 4;
    const isDesktopSideContent = !isMobile && isSideContent;
    if (isDesktopSideContent || hasEnoughDesktopCards || mobileCarouselEnabled) {
      this.dom.carousel.style.display = "block"
      this.dom.disabledCarousel.style.display = "none"
    } else {
      this.dom.carousel.style.display = "none"
      this.dom.disabledCarousel.style.display = "block"
    }

    if (isSideContent && this.slickInstance) {
      this.slickInstance.on('beforeChange', (evt, slick, curSlide, nextSlide) => {
        if (slick.options.infinite) return;

        // phantom slide, so we start from one
        if (nextSlide === 1) {
          this.toggleArrow('prev', false);
        } else if (nextSlide === cardsNumber - 1) {
          this.toggleArrow('next', false);
        } else {
          this.toggleArrow('prev', true);
          this.toggleArrow('next', true);
        }
      });

      this.slickInstance.slick('slickGoTo', 1);
    }

  }

  toggleArrow(which, enable) {
    const toggleElem = elem => {
      elem.classList.toggle(this.CSS.hidden, !enable);
    }

    const arrows = {
      prev: this.dom.prevArrow,
      next: this.dom.nextArrow,
    };

    toggleElem(arrows[which]);
  }
}